import React from 'react';
import PropTypes from 'prop-types';

import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';

import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';

import FormatDollarAmount from '../FormatDollarAmount.jsx';
function CommGrossYearOverYearRow({ item }) {
  return (
    <TableRow>
      <TableCell>{item.ProductGroup}</TableCell>
      <TableCell>
        <FormatDollarAmount amount={item.PreviousYearGrossSales} />
      </TableCell>
      <TableCell>
        <FormatDollarAmount amount={item.CurrentYearGrossSales} />
      </TableCell>
      <TableCell>
        {item.Change > 0 ? (
          <ArrowUpwardIcon sx={{ color: 'green', verticalAlign: 'middle', fontSize: 'small' }} />
        ) : (
          <ArrowDownwardIcon sx={{ color: 'red', verticalAlign: 'middle', fontSize: 'small' }} />
        )}
        <FormatDollarAmount amount={item.Change} />
      </TableCell>
    </TableRow>
  );
}
CommGrossYearOverYearRow.propTypes = { item: PropTypes.object.isRequired };
export default React.memo(CommGrossYearOverYearRow);
